// src/hotelApi.js
import axios from "axios";

function normalize(u) {
  return String(u || "").trim().replace(/\/+$/, "");
}

function isLocalHost() {
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
}

function computeHotelApiBase() {
  const stored = localStorage.getItem("hotel_api_base");
  if (stored) return normalize(stored);

  if (isLocalHost()) {
    return "http://localhost/hotel_server.php";
  }

  return "https://cozybnb.kendiservers.com/hotel_server.php";
}

export const HOTEL_API_BASE = computeHotelApiBase();

export const hotelApi = axios.create({
  baseURL: HOTEL_API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 20000,
});

hotelApi.interceptors.request.use((config) => {
  const storeId = Number(localStorage.getItem("store_id") || 0);
  const username = String(
    localStorage.getItem("username") ||
      localStorage.getItem("saved_username") ||
      localStorage.getItem("user") ||
      ""
  ).trim();

  config.headers = config.headers || {};

  if (storeId > 0) {
    config.headers["X-Store-ID"] = String(storeId);
  } else {
    delete config.headers["X-Store-ID"];
  }

  if (username) {
    config.headers["X-User"] = username;
  } else {
    delete config.headers["X-User"];
  }

  return config;
});

hotelApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("[HOTEL API ERROR]", {
      baseURL: error?.config?.baseURL || HOTEL_API_BASE,
      url: error?.config?.url,
      method: error?.config?.method,
      status: error?.response?.status,
      data: error?.response?.data,
    });
    return Promise.reject(error);
  }
);

console.log("[HOTEL API] baseURL =", HOTEL_API_BASE);